import { Injectable } from '@angular/core';
import { TypeLoading } from '@app/enums';
import { ModalFullLoadingComponent } from '@app/shared/modals/modal-full-loading/modal-full-loading.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoadingService {

  loadings = {
    [TypeLoading.FOOTER_LOADING]: {
      loadingCount: 0,
      loading: new BehaviorSubject<boolean>(null),
      loading$: undefined,
      init() {
        this.loading$ = this.loading.asObservable();
      },
      show() {
        this.loadingCount++;
        if (this.loadingCount == 1) {
          this.loading.next(true);
        }
      },
      hideLoading() {
        this.loadingCount--;
        if (this.loadingCount < 0) {
          this.loadingCount = 0;
        }
        if (this.loadingCount == 0) {
          this.loading.next(false);
        }
      }
    },
    [TypeLoading.COMPONENT_LOADING]: {
      loadingCount: 0,
      loading: new BehaviorSubject<boolean>(null),
      loading$: undefined,
      init() {
        this.loading$ = this.loading.asObservable();
      },
      show() {
        this.loadingCount++;
        if (this.loadingCount == 1) {
          this.loading.next(true);
        }
      },
      hideLoading() {
        this.loadingCount--;
        if (this.loadingCount < 0) {
          this.loadingCount = 0;
        }
        if (this.loadingCount == 0) {
          this.loading.next(false);
        }
      }
    },
    [TypeLoading.FULL_LOADING]: {
      loadingCount: 0,
      modal: undefined,
      modalService: undefined,
      init(modalService) {
        this.modalService = modalService;
      },
      show() {
        this.loadingCount++;
        if (!this.modal) {
          this.modal = this.modalService.open(ModalFullLoadingComponent,
            {
              size: 'full',
              backdrop: 'static',
              keyboard: false,
              windowClass: 'colibri-fullscreen-modal',
              backdropClass: 'colibri-fullscreen-modal-backdrop',
            });
          this.modal.componentInstance.typeLoading = 'FULL_LOADING';
        }
      },
      hideLoading() {
        this.loadingCount--;
        if (this.loadingCount < 0) {
          this.loadingCount = 0;
        }
        if (this.loadingCount == 0) {
          this.modal?.dismiss();
          this.modal = null;
        }
      }
    }
  }

  constructor(
    private _modalService: NgbModal
  ) {
    this.loadings[TypeLoading.FOOTER_LOADING].init();
    this.loadings[TypeLoading.COMPONENT_LOADING].init();
    this.loadings[TypeLoading.FULL_LOADING].init(_modalService);
  }

  showLoading(typeLoading: TypeLoading) {
    this.loadings[typeLoading].show();
  }

  hideLoading(typeLoading: TypeLoading) {
    this.loadings[typeLoading].hideLoading();
  }
}
